import * as yup from "yup";
export const changeLocationValidationSchema = yup
  .object({
    barcode: yup
      .string()
      .trim()
      .required()
      .notOneOf(["999-9-99"], "No se puede cambiar una caja a esa ubicación"),
    is_extra_location: yup.boolean().required().default(false),
  })
  .required();
